import API from './resources'

const actions = {
  async disableCopy({ commit }, payload) {
    let data, token
    [ data, token ] = payload
    try {
      const response = await API.disableCopy(data, token)
      return response
    } catch (error) {
      return error
    }
  },
  async updateCopy({ commit }, payload) {
    let data, token
    [ data, token ] = payload
    try {
      const response = await API.updateCopy(data, token)
      return response
    } catch (error) {
      return error
    }
  },
  async postCopy({ commit }, payload) {
    let data, token
    [ data, token ] = payload
    try {
      const response = await API.postCopy(data, token)
      return response
    } catch (error) {
      return error
    }
  },
  async getCopies({ commit, state }, payload) {
    try {
      if (state.is_active === null)  {
        const response = await API.getAllCopies(
          state.page,
          state.size,
          state.product_id,
          payload.token
        )
        commit('SET_COPIES_LIST', response.data)
        commit('SET_COPIES_PAGINATION', response.data)
      } else {
        const response = await API.getFilteredCopies(
          state.is_active,
          state.page,
          state.size,
          state.product_id,
          payload.token
        )
        commit('SET_COPIES_LIST', response.data)
        commit('SET_COPIES_PAGINATION', response.data)
      }
    } catch (error) {
      return error
    }
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/copy/actions.js